import { cleanUpObjRecursive } from "@utils/helpers";

import { getProductsFromResponse } from "@services/algolia/search/helpers/response.helpers";
import { ParamsAlgolia } from "@services/algolia/types/paramsAlgolia.types";

import { ProductAlgoliaModel } from "../../../@types/service/product/algolia/product.algolia.model";
import { AlgoliaClient } from "../types/client.types";
import { AlgoliaSearchQuery } from "../types/search.types";

const searchProducts =
    (searchClient: AlgoliaClient) =>
    ({ indexName, query, limit, filters }: ParamsAlgolia) => searchClient
        .searchForHits<ProductAlgoliaModel>({
            requests: [cleanUpObjRecursive({
                indexName,
                query,
                hitsPerPage: limit,
                page: 0,
                filters: filters,
            }) satisfies AlgoliaSearchQuery],
        })
        .then(getProductsFromResponse);

export { searchProducts };
